export function nextTick(): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, 0);
  });
}

export function debugLog(message?: any, ...optionalParams: any[]): void {
  if (import.meta.env.DEV) {
    if (typeof message === "string") {
      message = `debug: ${message}`;
    } else {
      optionalParams = [message, ...optionalParams];
      message = "debug";
    }
    console.log(message, ...optionalParams);
  }
}
